import { Http} from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class StorageServiceProvider {
  constructor(public http: Http) {
    console.log('Hello StorageServiceProvider Provider');
  }
  public setToken(key,value) {   
    localStorage.setItem(key, value);
  }   
  public getToken(key) {
    var token = localStorage.getItem(key);
    return token;
  }
  public clearToken() {
    localStorage.clear();
  }

}



// WEBPACK FOOTER //
// ./src/providers/storage-service/storage-service.ts